import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Router } from '@angular/router';
import { Observable } from 'rxjs-compat/Observable'
import { LabApiConfiguration } from '../apiConfiguration';
import { TestInstruction } from '../../../models/lab/testInstruction';
import { ServiceBase } from 'app/shared/infrastructure/serviceBase.component'; // leaf import - do not revert to the barrel (app/shared/infrastructure), breaks ng test (circular dependency)

@Injectable()
export class TestsInstructionService extends ServiceBase {

    private actionUrl: string;
    private url: string;

    constructor(private _http: HttpClient, private _configuration: LabApiConfiguration, private _router: Router) {
        super();
        this.actionUrl = _configuration.server;
        this.url = this.actionUrl + _configuration.testInstruction.url;
    }

    getAll = (): Observable<TestInstruction[]> => {
        return this._http.get<any>(this.url)
    }

    add = (data: any) => {
        return this._http.post<any>(this.url, data);
    }

    put = (data: any) => {
        return this._http.put<any>(this.url, data);
    }

    delete = (id: number) => {
        const url = `${this.url}/${id}`;
        return this._http.delete(url);
    }
}
